import validate from "/github/workspace/node_modules/nuxt/dist/pages/runtime/validate.js";
import show_45placeholder_45global from "/github/workspace/middleware/show-placeholder.global.ts";
import manifest_45route_45rule from "/github/workspace/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  show_45placeholder_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}